<div class="file-incident-table-container">
	<div [class.fullscreen]="isFullscreen$ | async">
		<cmms-locations-section
			[locationsInputList]="locationValue()"
			[isRequired]="true"
			(controlReady)="addChildControl('locations', $event)"
			(locationsChanged)="locationValue.set($event)"
		></cmms-locations-section>

		@for (incidentItem of incidentTaskArray(); track incidentItem) {
			<div class="incident-form">
				<hr class="h-line" />
				<file-incident-item
					(changeStatus)="changeStatus($event)"
					[incidentItem]="incidentItem"
				></file-incident-item>
			</div>
		}
	</div>
</div>
